import { render } from "./ExperienceSection.vue?vue&type=template&id=04acbe8a&scoped=true"
import script from "./ExperienceSection.vue?vue&type=script&lang=js"
export * from "./ExperienceSection.vue?vue&type=script&lang=js"

import "./ExperienceSection.vue?vue&type=style&index=0&id=04acbe8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04acbe8a"]])

export default __exports__